<script>
import { mapState, mapGetters } from 'vuex'
export default {
    name: 'NavBar',
    data: () => ({
      drawer: false,
      group: null,
      items: [
        {
          name: 'Campaign Tool',
          route: '/campaigns'
        },
        {
          name: 'Home',
          route: '/home'
        },
        {
          name: 'Create New Merchant',
          route: '/merchant/0',
        },
        {
          name: 'Profanity Manager',
          route: '/profanitymanager'
        },
        {
          name: 'Site Group Search',
          route: '/sitegroupsearch'
        },
        {
          name: 'Site Search (BroadReach/StorePoint)',
          route: '/retailer/0/sitefilter'
        }
      ]
    }),
    computed: {
      ...mapState ({
        username: state => state.user.username,
        environment: state => state.user.environment
      }),
      ...mapGetters ({
        loggedIn: 'user/loggedIn'
      })
    }
}
</script>

<template>
  <div>
    <v-app-bar>
      <v-app-bar-nav-icon v-if="loggedIn" @click="drawer = true"></v-app-bar-nav-icon>
      <router-link style="text-decoration: none" to="/home">
        <v-toolbar-title class="black--text font-weight-black"> <span class="primary--text">Fusion</span><span class="secondary--text">92</span> FSI <v-icon class="pb-1">mdi-shopping-outline</v-icon></v-toolbar-title>
      </router-link>
      <v-spacer></v-spacer>
      <p class="pt-2 font-weight-bold" v-if="loggedIn">Welcome {{ username }}. Environment: {{ environment }}
      <v-btn class="ml-2" depressed color="accent" @click="$store.dispatch('user/USER_LOGOUT')">
        Logout<v-icon right>mdi-logout</v-icon>
      </v-btn>
      </p>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
    >
      <v-list-item @click="$router.push('/home')">
        <v-list-item-content>
          <v-list-item-title class="black--text font-weight-black">
            <span class="primary--text">Fusion</span><span class="secondary--text">92</span> FSI <v-icon small>mdi-shopping-outline</v-icon>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list
        nav
        dense
      >
        <v-list-item color="primary" v-for="item in items" :key="item.name" style="text-decoration: none" :to="item.route">
          <v-list-item-title> {{ item.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>
